import React from 'react';
import { Button, Modal, Container } from 'react-bootstrap';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-tomorrow';

class ScriptViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        
        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
    }

    hideHandler() {
        this.setState({ show: false });
    }

    showHandler() {
        this.setState({ show: true });
    }

    render() {
        return (
            <div>
                <Button
                    variant="light"
                    onClick={this.showHandler}
                >
                    Display Script
                </Button>
                <div className="modal-container">
                    <Modal
                        show={this.state.show}
                        onHide={this.hideHandler}
                        centered
                        dialogClassName="asset-modal-wide"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                Script Content
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <AceEditor
                                mode="javascript"
                                theme="tomorrow"
                                name="script_viewer"
                                readOnly={true}
                                value={this.props.script || ''}
                                width="800px"
                                height="400px"
                                setOptions={{ 
                                    useWorker: true
                                }}
                                editorProps={{
                                    $blockScrolling: true
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.hideHandler}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default ScriptViewer; 